import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://d69dbe93bce1940b008b5ad635a86d7f@sentry-lt.leiturinha.com.br/4',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  sendClientReports: false,
  sampleRate: 0.1,
  // Tracing
  tracesSampleRate: 0, //  Capture 0% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/leiturinha\.api-staging\.dc\.pkds\.it/,
    /^https:\/\/leiturinha\.api\.dc\.pkds\.it/
  ],
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  ignoreErrors: [
    /Network Error/,
    /Failed to fetch/,
    /Script error/,
  ],
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

